/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useState, useEffect } from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Tooltip, Menu, MenuItem } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { authActions } from 'modules/common/auth/slice';
import Preference from 'modules/users/components/preference';
import TOAST_TYPES from 'modules/common/constants/toast-types';
import ERROR_TYPES from 'modules/common/constants/error-types';
import MODULE from 'modules/common/constants/modules';
import { selectIsOtpSent } from 'modules/users/selectors';
import { selectNotification } from 'modules/common/notifications/selectors';
import { notificationActions } from 'modules/common/notifications/slice';
import calculateActiveUserTime from 'modules/common/utils/active-user-time';
import { toast } from 'react-toastify';
import { IconButton } from './style';
/**
 * Navigation bar user dropdown common component that
 * uses across modules for display user options
 */
const NavbarUserDropdown = () => {
  const dispatch = useDispatch();
  //
  const [anchorMenu, setAnchorMenu] = useState(null);
  const [showPreference, setShowPreference] = useState(false);
  //
  const notification = useSelector(selectNotification);
  const isOtpSent = useSelector(selectIsOtpSent);
  // open user menu
  const toggleMenu = (event) => {
    setAnchorMenu(event.currentTarget);
  };
  // close user menu and reset notifications
  const closeMenu = () => {
    setAnchorMenu(null);
    setShowPreference(false);
    dispatch(notificationActions.resetNotification());
  };
  // sign out
  const handleSignOut = async () => {
    // calculate the user activeness on signout
    calculateActiveUserTime();
    dispatch(authActions.signOut());
  };
  // checks for notification and toast notification and close menu
  useEffect(() => {
    if (
      notification?.type === ERROR_TYPES.SUCCESS &&
      notification?.message !== '' &&
      (notification?.module === MODULE.preference ||
        notification?.module === MODULE.updateUser ||
        notification.module === MODULE.verify)
    ) {
      toast(notification?.message, { type: TOAST_TYPES.SUCCESS });
      if (!isOtpSent) {
        closeMenu();
      }
    }
  }, [notification, isOtpSent]);
  //
  return (
    <>
      <Tooltip title="Account">
        <div className="account">
          <IconButton
            aria-owns={anchorMenu ? 'menu-app-bar' : undefined}
            aria-haspopup="true"
            onClick={toggleMenu}
            sx={{ color: 'white' }}
            size="large"
            id="auto-account"
          >
            <AccountCircleIcon />
          </IconButton>
        </div>
      </Tooltip>
      <Menu id="menu-app-bar" anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
        <MenuItem
          onClick={() => {
            setShowPreference(true);
          }}
          onClose={closeMenu}
        >
          Preferences
        </MenuItem>
        {showPreference && (
          <Preference
            open={showPreference}
            onClose={() => {
              setShowPreference(false);
              closeMenu();
            }}
          />
        )}
        <MenuItem onClick={handleSignOut} id="auto-sign-out">
          Sign out
        </MenuItem>
      </Menu>
    </>
  );
};
//
export default NavbarUserDropdown;
